// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageWrapper_page__Z5Cy8 {
  padding: 1rem;
  background-color: #ededed;
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/PageWrapper.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AACF","sourcesContent":[".page {\n  padding: 1rem;\n  background-color: #ededed;\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `PageWrapper_page__Z5Cy8`
};
export default ___CSS_LOADER_EXPORT___;
